/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import PillButton from '../buttons/Pill';
import ArrowIcon from '../icons/Arrow';
import Accordion from '../partials/Accordion';
import BaseBlocks from './BaseBlocks';
import * as BlockComponents from './index-accordion';

import styles from '../../../styles/blocks/accordion.module.scss';

const propTypes = {
    title: PropTypes.string.isRequired,
    blocks: AppPropTypes.blocks,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    blocks: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const AccordionBlock = ({ title, blocks, className, isContainer, containerClassName }) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <div
            className={classNames([
                'blockAccordion',
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            <Accordion
                iconComponent={<PillButton className={styles.toggleButton} icon={<ArrowIcon />} />}
                label={title}
                className={styles.accordion}
                itemClassName={styles.item}
                isOpenClassName={styles.isOpen}
                titleClassName={styles.title}
                toggleClassName={styles.toggle}
                toggleButtonClassName={styles.toggleButton}
                itemWrapperClassName={styles.itemWrapper}
                childrenClassName={styles.children}
            >
                <div className={styles.left}>
                    <BaseBlocks blocks={blocks} components={BlockComponents} />
                </div>
            </Accordion>
        </div>
    </div>
);

AccordionBlock.propTypes = propTypes;
AccordionBlock.defaultProps = defaultProps;

export default AccordionBlock;
